import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

import { MaterialSymbol } from '@/components/MaterialSymbol';

/**
 * A side panel section's heading — ported from Web's `ui/SectionHeading`: a
 * 20px icon in fog-80 before the title in bodyRegularMono 14, fog-80. Project
 * details' panel and Planning's task panel head their sections with it, so
 * the two right panels read alike (3 Nov, Mette).
 */
export type SectionHeadingProps = {
  /** Material Symbols glyph name. */
  icon: string;
  children: ReactNode;
  /** Heading level; `h2` as in Web. */
  component?: 'h2' | 'h3' | 'h4';
  automationId?: string;
};

export const SectionHeading = ({
  icon,
  children,
  component = 'h2',
  automationId,
}: SectionHeadingProps) => (
  <Stack
    direction="row"
    data-automation-id={automationId}
    sx={{ alignItems: 'center', gap: 1, color: 'var(--color-fog-80)' }}
  >
    <MaterialSymbol name={icon} size={20} />
    <Typography variant="bodyRegularMono" component={component} sx={{ color: 'inherit', m: 0 }}>
      {children}
    </Typography>
  </Stack>
);
